import type { UploadFile } from "antd";
import DocumentModel from "./DocumentModel";
import AttachDocumentDto from "../../dto/Documents/AttachDocumentDto";
import getDocumentUrl from "../../utils/getDocumentUrl";

// Этот тип используем в формах, приводим к виду antd upload
export type AttachDocumentFormModel = UploadFile<DocumentModel> & {
  dbId: number; // сохраняем id записи в сущности
};

export type AttachDocumentUpdateType = AttachDocumentDto;

type AttachDocumentModel = AttachDocumentDto;
export default AttachDocumentModel;

export class AttachDocumentDataConverter {
  static convertDocumentsToFormData(documents: Array<AttachDocumentDto>, host: "WEB" | "BITRIX"): Array<AttachDocumentFormModel> {
    return documents.map((x) => ({
      dbId: x.id,
      uid: window.crypto.randomUUID(),
      name: x.documentName,
      status: "done",
      response: {
        id: x.documentId,
        name: x.documentName,
        isCheckedForDelete: false,
        size: undefined!,
        typeId: undefined!,
      },
      url: getDocumentUrl(x.documentId, host),
    }));
  }

  static convertDocumentsToUpdate(documents: Array<AttachDocumentFormModel>): Array<AttachDocumentUpdateType> {
    return documents
      .filter((x) => x.status === "done")
      .map((x) => ({
        id: x.dbId,
        documentId: x.response!.id,
        documentName: x.response!.name,
      }));
  }
}
